export const VIEWS = {
    SELECT_USER_ROLE: 'SELECT_USER_ROLE',
    SELECT_INTERESTS: 'SELECT_INTERESTS',
}
